<script>
import MOTOR_OCR from "@/constants/MotorOCR";

export default {
  name: "OcrPreviewModal",
  data() {
    return {
      MOTOR_OCR,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    proveedorNombre: {
      type: String,
      default: "",
    },
    proveedorRut: {
      type: String,
      default: "",
    },
    tipoPago: {
      type: String,
      default: "",
    },
    monto: {
      type: [String, Number],
      default: "",
    },
    fechaFormateada: {
      type: String,
      default: "",
    },
    nroDocumento: {
      type: [String, Number],
      default: "",
    },
    previewUrl: {
      type: String,
      default: null,
    },
    ocrEngine: {
      type: String,
      default: "",
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<template>
  <b-modal
    v-model="modalVisible"
    title="Validación de OCR"
    size="xl"
    ok-only
    ok-title="Confirmar"
    @hidden="$emit('hidden')"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="flex flex-col gap-4">
        <div class="flex items-center justify-between mb-2">
          <h5 class="font-bold text-lg m-0">Datos Extraídos:</h5>
          <span 
            v-if="ocrEngine" 
            class="text-xs font-bold px-2 py-1 rounded"
            :class="ocrEngine === MOTOR_OCR.GEMINI ? 'bg-indigo-100 text-indigo-800 border border-indigo-200' : 'bg-gray-200 text-gray-800 border border-gray-300'"
          >
            OCR: {{ ocrEngine }}
          </span>
        </div>
        <div class="flex flex-col gap-3 bg-gray-50 p-6 rounded-lg border text-base">
          <div class="flex justify-between items-start gap-4 border-b pb-2">
            <span class="font-bold text-gray-700 shrink-0">Proveedor:</span>
            <div class="text-right flex-1 break-words">
              {{ proveedorNombre }} <span class="whitespace-nowrap">| {{ proveedorRut }}</span>
            </div>
          </div>
          <div class="flex justify-between items-start gap-4 border-b pb-2">
            <span class="font-bold text-gray-700 shrink-0">Tipo de Pago:</span>
            <span class="text-right">{{ tipoPago }}</span>
          </div>
          <div class="flex justify-between items-start gap-4 border-b pb-2">
            <span class="font-bold text-gray-700 shrink-0">Monto:</span>
            <span class="text-right">{{ monto }}</span>
          </div>
          <div class="flex justify-between items-start gap-4 border-b pb-2">
            <span class="font-bold text-gray-700 shrink-0">Fecha Documento:</span>
            <span class="text-right">{{ fechaFormateada }}</span>
          </div>
          <div class="flex justify-between items-start gap-4">
            <span class="font-bold text-gray-700 shrink-0">N° Documento:</span>
            <span class="text-right">{{ nroDocumento }}</span>
          </div>
        </div>
        <div class="alert alert-info mt-4" role="alert">
           Por favor verifique que los datos extraídos coincidan con el documento adjunto. Si hay algún error, puede cerrar esta ventana y editar los campos manualmente en el formulario.
        </div>
      </div>
      <div>
        <h5 class="font-bold text-lg mb-2">Documento:</h5>
        <iframe
          v-if="previewUrl"
          :src="previewUrl"
          class="w-full h-[60vh] border rounded-lg"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </b-modal>
</template>
